module.exports = __webpack_public_path__ + "static/media/totalRemainingSession.eb743d06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/totalRemainingSession.svg
// module id = 838
// module chunks = 1